module.exports = {
  siteTitle: 'Dan Studdert', // <title>
  manifestName: "Dan Studdert's Portfolio",
  manifestShortName: 'Landing', // max 12 characters
  manifestStartUrl: '/',
  manifestBackgroundColor: '#663399',
  manifestThemeColor: '#663399',
  manifestDisplay: 'standalone',
  manifestIcon: 'src/assets/img/website-icon.png',
  pathPrefix: ``, // This path is subpath of your hosting https://domain/portfolio
  firstName: 'Dan',
  lastName: 'Studdert',
  // social
  socialLinks: [
    {
      icon: 'fa-linkedin-in',
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/daniel-studdert-367846175/',
    },
    {
      icon: 'fa-twitter',
      name: 'Twitter',
      url: 'https://twitter.com/danstuddert',
    },
  ],
  resumeLink: 'https://folio-email.s3.amazonaws.com/files/Resume.pdf',
  email: 'hello@danielstuddert.com',
  address: 'Melbourne, Australia'
};
